import { SHOW_MESSAGE, SHOW_MESSAGE_SUCCESS, SHOW_MESSAGE_ERROR, SHOW_MESSAGE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ShowMessage = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      state = { ...state, loading: true, success: false, error: false, message: null };
      break;
    case SHOW_MESSAGE_SUCCESS:
      state = { ...state, data: action.payload, loading: false, success: true, error: false };
      break;
    case SHOW_MESSAGE_ERROR:
      state = { ...state, data: null, loading: false, success: false, error: true, message: action.payload };
      break;
    case SHOW_MESSAGE_EMPTY:
      state = { ...initialState };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ShowMessage;
